export enum CreditNoteStatusId {
  Outstanding = 1,
  Removed = 2,
  AppliedInFull = 3,
  Held = 4,
  Pending = 5,
  ImportError = 6,
}

/**
 * A partial mapping of CreditNoteStatusId to include statuses that are relevant to payees.
 * For payees, CreditNoteStatusId are returned as negative values for the list page since
 * credit notes are returned along with invoices.
 */
export const PayeeCreditNoteStatusId = {
  /* eslint-disable @typescript-eslint/naming-convention */
  AppliedInFull: -(CreditNoteStatusId.AppliedInFull) as CreditNoteStatusId,
  Outstanding: -(CreditNoteStatusId.Outstanding) as CreditNoteStatusId,
  /* eslint-enable @typescript-eslint/naming-convention */
} as const;
